import type { FaireProductEntity } from "../../entity_types/product";

export const p_48ynqpssg5: FaireProductEntity = {
  token: "p_48ynqpssg5",
  type: "product",
  name: "Pleated Draped Gown",
  brandToken: "b_wrt3xtnbxw",
  brandName: "Aria Romance",
  imageUrl:
    "https://cdn.faire.com/fastly/647b142c8dcaf45d88b50982ff3f747fb8c360533c8ad45baa290e8a65e5c5c5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cfa7c56ba24f825ce5519e06499d47afb2aaa7123e8f59d16de79a0af83fa93b.jpeg",
    "https://cdn.faire.com/fastly/88a5f54dded60029d20534ff577654be82bcf06a4e771fb6c2b600cd147bb23b.jpeg",
    "https://cdn.faire.com/fastly/6d2f27e8a94d824b6a7b1337cb3da31e6808613ed7b3922ecfff9c448b4eba21.jpeg",
    "https://cdn.faire.com/fastly/874b4dfd86f34f33ad77e4d3574c412d279cf96f751884033aa59540924d3ac6.jpeg",
    "https://cdn.faire.com/fastly/983495aed9665033291b4e73c102066f27dcfb3007f43520de302b9ccab8eb86.jpeg",
    "https://cdn.faire.com/fastly/b16672f993baf4f89b4c5ce74288938d5a27c30b8a955ee6eb01e9490be27d43.jpeg",
    "https://cdn.faire.com/fastly/8d4d2ef02b952205da282cf4abdcda9b955625509a0431eaebe2d4808cd2e12e.jpeg",
    "https://cdn.faire.com/fastly/5f8c81979efed0083cbdd2cea9fdbde796f96db57164bcc5b1ef5cc9ca5e7125.jpeg",
    "https://cdn.faire.com/fastly/65ec63fa37f8664b314ed06d665cfa0e72c1753a8a3653ac8090350cad065b31.jpeg",
    "https://cdn.faire.com/fastly/7a3bb99b5177d5021c49c64e3a57cd2ba2bbd3c06d56255eca97f95fc145fa2b.jpeg",
    "https://cdn.faire.com/fastly/f28710da50988944bafa3e26349c648cf98af95bf6d3a9df360ea72d68c85507.jpeg",
    "https://cdn.faire.com/fastly/24473bbdb66481f3d61153d0b6577639ab061354a746999e52fb64f2ca106e9c.jpeg",
    "https://cdn.faire.com/fastly/5e58807542be6cebf1cc99e82218d0b324d44418da7a7fc87181cfb7a4432306.jpeg",
    "https://cdn.faire.com/fastly/572b5f0fd0fd3068ba7724b9f7d701fb651eaae480d1259c09015de062c0ef44.jpeg",
    "https://cdn.faire.com/fastly/d65af280e0ef3061890b02bff76af2c937d9083b5bc8a2be1eed850c7c0e2d08.jpeg",
    "https://cdn.faire.com/fastly/d4c127866a30ed0815cbcabe77c05965d290b144d00da45d94395294855bc5e6.jpeg",
    "https://cdn.faire.com/fastly/53400e99ac8097be59b81b6e6e8d8562c63f43ee8cd46521c79c759dfc9b6fb5.jpeg",
    "https://cdn.faire.com/fastly/bfb508b296ada904ed1a34a6066e59dde9c662e8505ce62cc20b88e6af8a42bd.jpeg",
    "https://cdn.faire.com/fastly/c2a15c440f93e68fb85c9c6581388e175a8abc922d905aabad6742ea87c92e95.jpeg",
    "https://cdn.faire.com/fastly/fdca31d40cb535f4b8016e505fdbc49fd8b17239c93b56fe6338f72218becf55.jpeg",
    "https://cdn.faire.com/fastly/39d84c18d1895245b52d0c589003e7278de4a657afee3721daa70796993995dd.png",
  ],
  priceDollars: 32.33,
  description:
    "EXUDE SOPHISTICATED ELEGANCE IN THIS GRACEFUL GOWN, FEATURING A DRAPED NECKLINE AND ELEGANT PLEATED DETAIL FOR A TIMELESS, RED-CARPET READY SILHOUETTE.\n\nIMPORTED, DESIGNED IN USA\n\nDRAPED NECKLINE AND PLEATED BODICE\n\nFLOWING SKIRT AND FITTED WAIST\n\nCONT 95% POLYESTER 5% ELASTANE\n\nModel is 5'9\" and is wearing a small. Please see size chart for detail.\n\nPlease note: This product ships from China. We cover all customs and import duties for you! Delivery takes 4-5 business days after your order ships. Please contact us if you have any questions.\n\n",
  tags: [],
  msrpDollars: 65.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:54.684Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
